import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import EntriesSelector from '../Pagination/EntriesSelector';
import Pagination from '../Pagination/Paginations';

import { API_BASE_URL } from '../../config.js';
import {
  statisticsAction,
  statisticsCloseAction
} from '../../actions/settingsAction.js';

const Hrot = ({ fixNavbar }) => {

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("2");
  const [loading, setLoading] = useState(false);

  /* ================= HORIZONTAL SCROLL ================= */
  const tableScrollRef = useRef(null);
  const scrollTable = (direction) => {
    if (tableScrollRef.current) {
      tableScrollRef.current.scrollBy({
        left: direction === "left" ? -250 : 250,
        behavior: "smooth",
      });
    }
  };

  /* ================= FETCH DATA ================= */
  const fetchData = (filters = {}) => {
    setLoading(true);
    axios.get(API_BASE_URL + '/hr_overtime_list', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: {
        from_date: filters.from_date ?? "",
        to_date: filters.to_date ?? "",
        status: filters.status ?? "",
      },
    })
      .then(res => setData(res.data || []))
      .catch(() => toast.error("Failed to load overtime list"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData({ status: "2" });
  }, []);

  const handleFilter = () => {
    fetchData({ from_date: fromDate, to_date: toDate, status });
  };

  /* ================= SEARCH ================= */
  const filteredData = data.filter(item =>
    `${item.employee_id}${item.employee_name}${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= PAGINATION (Previous / Next style) ================= */
  const totalPages = Math.ceil(filteredData.length / perPage);
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const pageData = filteredData.slice(indexOfFirst, indexOfLast);

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
   {
  name: "Action",
  selector: row =>
    Number(row.dpt_status) === 2 &&
    Number(row.hr) === 1
      ? 1
      : 0,
  sortable: true,
  cell: row =>
    Number(row.dpt_status) === 2 &&
    Number(row.hr) === 1 ? (
      <Link to={`/hrcalcot?id=${row.overtime_id}`} title="View Details">
        <i className="fe fe-maximize" />
      </Link>
    ) : null,
  ignoreRowClick: true,
  width: "100px",
}
,
    {
      name: "Employee ID",
      selector: row => row.employee_id,
      sortable: true,
    },
    {
      name: "Employee",
      selector: row => row.employee_name,
      sortable: true,
      
    },
    {
      name: "Department",
      selector: row => row.department_name,
      sortable: true,
    },
    {
      name: "Overtime Hours",
      selector: row => row.overtime_hour,
      sortable: true,
    },
    {
      name: "Overtime Date",
      selector: row => row.overtime_date,
      sortable: true,
        width: "150px"
    },
   {
  name: "Reason",
  selector: row => row.reason || "", // keeps sorting working
  sortable: true,
  wrap: true,
  cell: row => {
    const reason = row.reason || "";
    const shortText =
      reason.length > 5 ? reason.substring(0, 5) + "..." : reason;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {reason}
        </div>
      </div>
    );
  },
}
,
    {
      name: "Incharge",
      cell: row => ReactHtmlParser(row.incharge_status),
    },
   {
  name: "Incharge Remark",
  cell: row => {
    const remark = row.incharge_remark || "";
    const shortText =
      remark.length > 5 ? remark.substring(0, 5) + "..." : remark;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {remark}
        </div>
      </div>
    );
  },
  sortable: true,
}
,
    {
      name: "HOD",
      cell: row => ReactHtmlParser(row.hod_status),
    },
 {
  name: "HOD Remark",
  cell: row => {
    const remark = row.hod_remarks || "";
    const shortText =
      remark.length > 5 ? remark.substring(0, 5) + "..." : remark;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {remark}
        </div>
      </div>
    );
  },
  sortable: true,
},

    {
      name: "HR",
      cell: row => ReactHtmlParser(row.hr_status),
       sortable: true,
    },
    {
  name: "ManualOT",
  cell: row =>
    row.manual_ot === 1 ? (
      <span className="badge badge-danger">Manual OT</span>
    ) : (
      <span className="badge badge-secondary">---</span>
    ),
  sortable: true,
}

    
  ];

  return (
    <>
      <ToastContainer />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">
          <div className="card">

            {/* HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
      <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
          <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
        </svg>
        Manage Overtime
      </h3>

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <EntriesSelector
                entriesPerPage={perPage}
                setEntriesPerPage={setPerPage}
                setCurrentPage={setCurrentPage}
              />
              <div style={{ position: "relative", width: "300px" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                  style={{ paddingRight: "30px" }}
                />
                {searchTerm && (
                  <span
                    onClick={() => setSearchTerm("")}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#aaa",
                      fontSize: "18px"
                    }}
                  >
                    ✖
                  </span>
                )}
              </div>
              </div>
            </div>

            {/* FILTER BAR */}
            <div className="card-body border-bottom py-2">
              <div className="row align-items-end">
                <div className="col-md-3 col-sm-6 mb-2">
                  <label className="form-label mb-1">From Date</label>
                  <DatePicker
                    selected={fromDate ? new Date(fromDate) : null}
                    onChange={(date) =>
                      setFromDate(date ? date.toLocaleDateString("en-CA") : "")
                    }
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select From Date"
                    className="form-control w-100"
                    wrapperClassName="w-100"
                    maxDate={toDate ? new Date(toDate) : null}
                    isClearable
                  />
                </div>
                <div className="col-md-3 col-sm-6 mb-2">
                  <label className="form-label mb-1">To Date</label>
                  <DatePicker
                    selected={toDate ? new Date(toDate) : null}
                    onChange={(date) =>
                      setToDate(date ? date.toLocaleDateString("en-CA") : "")
                    }
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Select To Date"
                    className="form-control w-100"
                    wrapperClassName="w-100"
                    minDate={fromDate ? new Date(fromDate) : null}
                    isClearable
                  />
                </div>
                <div className="col-md-3 col-sm-6 mb-2">
                  <label className="form-label mb-1">Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="2">Approved</option>
                    <option value="1">Pending</option>
                    <option value="3">Rejected</option>
                  </select>
                </div>
                <div className="col-md-3 col-sm-6 mb-2">
                  <button
                    type="button"
                    className="btn btn-primary w-auto"
                    onClick={handleFilter}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </div>

            {/* TABLE */}
            <div className="card-body" style={{ position: "relative" }}>
              {/* Left scroll arrow */}
              <button
                type="button"
                onClick={() => scrollTable("left")}
                title="Scroll left"
                style={{
                  position: "absolute",
                  left: "-2px",
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 5,
                  border: "none",
                  background: "transparent",
                  color: "#e96827",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: 1,
                  cursor: "pointer",
                }}
              >
                &laquo;
              </button>

              {/* Right scroll arrow */}
              <button
                type="button"
                onClick={() => scrollTable("right")}
                title="Scroll right"
                style={{
                  position: "absolute",
                  right: "-2px",
                  top: "45%",
                  transform: "translateY(-50%)",
                  zIndex: 5,
                  border: "none",
                  background: "transparent",
                  color: "#e96827",
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: 1,
                  cursor: "pointer",
                }}
              >
                &raquo;
              </button>

              <div
                className="table-responsive"
                ref={tableScrollRef}
                style={{ overflowX: "auto", width: "100%", padding: "0 22px" }}
              >
                <DataTable
                  columns={columns}
                  data={pageData}
                  highlightOnHover
                  striped
                  responsive={false}
                  persistTableHead
                  progressPending={loading}
                  noDataComponent="No overtime records found"
                />
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  statisticsOpen: state.settings.isStatistics,
  statisticsClose: state.settings.isStatisticsClose,
});

const mapDispatchToProps = (dispatch) => ({
  statisticsAction: (e) => dispatch(statisticsAction(e)),
  statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hrot);
